<script context="module" lang="ts">
  export const TYPE = {
    BUTTON: 'button',
    SUBMIT: 'submit',
    RESET: 'reset',
  } as const

  export const COLOR = {
    PRIMARY: 'primary',
    WARNING: 'warning',
    DANGER: 'danger',
    LIGHT: 'light',
  } as const

  type Type = typeof TYPE[keyof typeof TYPE]
  type Color = typeof COLOR[keyof typeof COLOR]
</script>

<script lang="ts">
  import cx from 'classnames'

  let className = ''
  export { className as class }
  export let color: Color = COLOR.PRIMARY
  export let type: Type = TYPE.BUTTON
  export let disabled = false
</script>

<button
  {type}
  class={cx('btn', className)}
  class:btn-primary={color === COLOR.PRIMARY}
  class:btn-warning={color === COLOR.WARNING}
  class:btn-danger={color === COLOR.DANGER}
  class:btn-light={color === COLOR.LIGHT}
  {disabled}
  {...$$restProps}
  on:click
>
  <slot />
</button>
